import { useMemo, useRef, useState } from 'react';

import { uniframeReady, webapi } from '@spot-fe/utils';
import { useI18n, useUserInfo } from '@spot-fe/base-ui';
import { useParams } from 'next/navigation';
import { message } from '@bfe/lux';

interface IShareCommon {
  setProperty: (key: string, value: any) => IShareModal;
  subscribeEvent: (event: string, callback: any) => IShareModal;
  init: () => Promise<IShareModal>;
}
export interface IShareModal extends IShareCommon {
  // events: {
  //   HIDE_MODAL: string;
  //   REGISTER_SUCCESS: string;
  // };
  properties: {
    VISIBLE: string;
    CONFIG: string;
  };
}

const urlUtm = 'sa_utm_ci=AD0003&utm_source=ref&sa_utm_channel=ref_';

export function useShare() {
  const { t } = useI18n();
  const params = useParams();
  const { isLogin, userInfo } = useUserInfo();
  const [isLoading, setIsLoading] = useState(false);
  const [readyState, setReadyState] = useState(-1);
  const shareRef = useRef<IShareModal>();
  const inviteCode = useRef('');

  const getInviteCode = async () => {
    if (!isLogin || inviteCode.current) return;

    const res = await webapi.get<{
      affiliate_id: number;
      data: Array<{ code: string; status: string }>;
    }>('/s1/code/info-msg', { client_id: userInfo?.id, scene: 2 });
    const { success, result, message: msg } = res;
    if (!success) {
      message.error(msg);
      setIsLoading(false);
      return;
    }
    // 注意：只有状态为0的邀请码才可用
    if (
      result.data.length &&
      Number(result.data[0].status) === 0 &&
      result.data[0].code
    ) {
      inviteCode.current = result.data[0].code;
    }
  };

  const init = async () => {
    await uniframeReady();
    return new Promise((resolve, reject) => {
      (window as any)?.BybitUniFrame?.ready(
        ({ share }: { share: IShareModal }) => {
          share
            .init()
            .then(() => {
              setReadyState(1);
              shareRef.current = share;
              resolve(true);
            })
            .catch(() => {
              setReadyState(0);
              reject();
            });
        }
      );
    });
  };

  const link = useMemo(() => {
    const { origin } = window.location;
    // todo
    // const path = isM ? replace('/trade/spot/m/launchpad') : replace('/trade/spot/launchpad');
    const path = `/${params.lang}/trade/spot/launchpad`;
    const linkWhole = inviteCode.current
      ? `${origin}${path}?ref=${inviteCode.current}&${urlUtm}`
      : `${origin}${path}?${urlUtm}`;
    return linkWhole;
  }, [params.lang]);

  const getShareConfig = (isOngoing: number) => {
    const contentDesc = isOngoing
      ? `<span>${t('lpn_invite_ad')}</span>`
      : t('lpn_invite_ad2');

    return {
      code: inviteCode.current,
      posterStyle: ['horizontal', 'vertical'],
      link,
      content: `${t('lpn_share_text', { link })}`,
      contentLabel: t('lpn_share_text_label'),
      poster: [
        {
          // 海报模板
          template: 'default',
          // 海报数据
          templateData: {
            backgroundImage: {
              vertical: '/spot-fe-launchpad/images/share-bg-m_2.png',
              horizontal: '/spot-fe-launchpad/images/share-bg-web_2.png',
            },
            // 自定义内容文案
            content: {
              desc: contentDesc,
            },
            bottom: {
              showCode: true,
            },
          },
        },
      ],
    };
  };

  const setVisible = async (isOngoing: number) => {
    try {
      if (readyState !== 1) {
        setIsLoading(true);
        await init();
      }
      await getInviteCode();
      // debugger
      if (shareRef.current && inviteCode.current) {
        const { VISIBLE, CONFIG } = shareRef.current.properties;
        shareRef.current.setProperty(CONFIG, getShareConfig(isOngoing));
        shareRef.current.setProperty(VISIBLE, true);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    openShareModal: setVisible,
    shareModalInitLoading: isLoading,
  };
}
